module.exports = __webpack_public_path__ + "img/19.d7ed8296.jpg";